import { render } from "./CDSPrivacyPolicy.vue?vue&type=template&id=906443f0&ts=true"
import script from "./CDSPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./CDSPrivacyPolicy.vue?vue&type=script&lang=ts"

import "./CDSPrivacyPolicy.vue?vue&type=style&index=0&id=906443f0&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__